import { useNavigate } from 'react-router-dom';
import { Footer } from '../First';

export function Dbms_op() {
  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <>
      <div className="front_container">
        <div className="front_contain">
          <h2>Back End Development</h2>
          <p>All the resources are available through the links below. These are the recommended platforms for your educational purpose.</p>
          <p>Created by <a href="https://www.linkedin.com/in/sayednowshad/" target="_blank" rel="noopener noreferrer">SayedNowshad</a></p>
        </div>
      </div>

      <h2>Description</h2>
      <ul>
        <li>Click below topics to unlock more concepts &#x1F512;</li>
        <li>Select the topic to explore further</li>
        <li>Share these resources with your friends!</li>
        <li>Thanks & Enjoy <strong>"Stay Hard, Stay Consistently"</strong></li>
      </ul>

      <h3>Content</h3>
      <div>
        <button onClick={() => navigateTo('/Dbms_MySQL')}>MySQL</button>
        <button onClick={() => navigateTo('/Dbms_MongoDB')}>MongoDB</button>
        <button onClick={() => navigateTo('/Dbms_FireBase')}>Firebase (Node.js)</button>
      </div>

      <Footer />
    </>
  );
}

export default Dbms_op;
